import { inject, type InjectionKey } from 'vue'

export interface ConfirmPort {
  confirm(message: string): boolean
}

export const CONFIRM_PORT: InjectionKey<ConfirmPort> = Symbol('ConfirmPort')

export const useConfirm = (): ConfirmPort => {
  const p = inject(CONFIRM_PORT, null)
  if (!p) throw new Error('ConfirmPort not provided')
  return p
}
